<k-area-blocker [showLoader]="_loading" [message]="_blockerMessage">
  <div class="kTreeContainer kOverrideFAIcons">
    <p-tree
      #tree
      *ngIf="selectionMode === 'multiple'"
      kCategoriesTreePropagation
      [propagateDownMode]="disablePropagation ? 'none' : 'preventNested'"
      [propagateUpMode]="disablePropagation ? 'none' : 'visualOnly'"
      [value]="_categories"
      [(selection)]="_selectedTreeNodes"
      (onNodeSelect)="_onNodeSelect($event.node)"
      (onNodeUnselect)="_onNodeUnselect($event)"
      (onNodeExpand)="_onNodeExpand($event)"
    >
      <ng-template let-node pTemplate="default">
        <div class="kTreeNodeLabelWrapper">
          <span class="kTreeNodeLabel" [kTooltip]="node.label" [delay]="1000">{{ node.label }}</span>
          <span class="kTreeNodeNumChildren" *ngIf="node.childrenCount">{{ node.childrenCount }}</span>
        </div>
        <div
          *ngIf="node.expanded && node.childrenStatus === 1"
          class="kLoadingMessage"
          (click)="_blockTreeSelection($event)"
        >
          {{ 'entriesShared.categoriesFilters.loading' | translate }}
        </div>
        <div
          *ngIf="node.expanded && node.childrenStatus === 2"
          class="kLoadingErrorMessage"
          (click)="_blockTreeSelection($event)"
        >
          {{ node.childrenLoadError || 'entriesShared.categoriesFilters.loadingError' | translate }}
        </div>
      </ng-template>
    </p-tree>

    <p-tree #tree *ngIf="selectionMode === 'single'" (onNodeExpand)="_onNodeExpand($event)" [value]="_categories">
      <ng-template let-node pTemplate="default">
        <div class="kTreeNodeLabelWrapper" (click)="_onNodeSelect(node)">
          <p-radioButton [value]="node" [ngModel]="_selectedTreeNode"></p-radioButton>
          <span class="kTreeNodeLabel kTreeNodeLabelSingle" [kTooltip]="node.label" [delay]="1000">{{
            node.label
          }}</span>
          <span class="kTreeNodeNumChildren" *ngIf="node.childrenCount">{{ node.childrenCount }}</span>
        </div>
        <div
          *ngIf="node.expanded && node.childrenStatus === 1"
          class="kLoadingMessage"
          (click)="_blockTreeSelection($event)"
        >
          {{ 'entriesShared.categoriesFilters.loading' | translate }}
        </div>
        <div
          *ngIf="node.expanded && node.childrenStatus === 2"
          class="kLoadingErrorMessage"
          (click)="_blockTreeSelection($event)"
        >
          {{ node.childrenLoadError || 'entriesShared.categoriesFilters.loadingError' | translate }}
        </div>
      </ng-template>
    </p-tree>
  </div>
</k-area-blocker>
